import React, { useContext } from "react"
import { Box, Typography, Button } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { ViewCart, CartContext } from "./Context"
import WhatsAppIcon from "@material-ui/icons/WhatsApp"
import { size } from "../config"
import TagPrice from "../widgets/TagPrice"
import { useStaticQuery, graphql } from "gatsby"
const useStyles = makeStyles(() => {
  return {
    Header: {
      // padding: size.normal,
      // background: color.grayLight,
      marginBottom: size.superBig,
      borderRadius: size.small,
      "& .title": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: `${size.big}px 0`,
      },
    },
    TotalPrice: {
      position: "fixed",
      bottom: 60,
      zIndex: 3,
      left: "50%",
      transform: "translateX(-50%)",
    },
  }
})
const Header = () => {
  const classes = useStyles()
  const { valueViewCart, setViewCart } = useContext(ViewCart)
  const { cart } = useContext(CartContext)
  const { money } = useContext(CartContext)
  let totalPrice = 0
  try {
    cart.products.forEach(product => {
      product.variants.forEach(variant => {
        totalPrice += variant.quantity * variant.price
      })
    })
  } catch (error) {
    console.warn("No hay productos añadidos aún")
  }
  const data = useStaticQuery(graphql`
    query siteTitle {
      sanitySetting {
        title
      }
    }
  `)
  const siteTitle = data.sanitySetting.title
  return (
    <header className={classes.Header}>
      <Typography
        className="title"
        color="primary"
        align="center"
        variant="h4"
        component="h1"
      >
        <WhatsAppIcon />
        {siteTitle}
      </Typography>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Button
          style={{ maxWidth: 250, marginRight: size.small }}
          fullWidth
          className="btn"
          color="primary"
          onClick={() => setViewCart(false)}
          variant={!valueViewCart ? "contained" : "outlined"}
        >
          productos
        </Button>
        <Button
          style={{
            maxWidth: 250,
            marginLeft: size.small,
            // color: "#ed0d2e",
            borderColor: "#ed0d2e",
          }}
          fullWidth
          className="btn"
          color="secondary"
          onClick={() => setViewCart(true)}
          variant={valueViewCart ? "contained" : "outlined"}
        >
          Ver Carrito
        </Button>
      </Box>
      {totalPrice !== 0 && (
        <TagPrice className={classes.TotalPrice}>
          TOTAL: {totalPrice} {money}
        </TagPrice>
      )}
    </header>
  )
}

export default Header
